function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26.13 16l-9.702 15.78h11.104L37.233 16 27.416.338H16.311L26.13 16zM.883.338L10.584 16 .883 31.662h11.104l9.701-15.779L11.987.338H.883z",
  fill: "#C08B4A"
});

function SvgArrowRightDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 38 32"
  }, props), _ref);
}

export default SvgArrowRightDouble;